export default {
  apiBaseUrl: 'API Base URL',
  apiUsername: 'API Username',
  apiToken: 'API Token',
  gbgConnection: 'GBG Connection',
  features: 'Features',
  addressValidation: 'Address Validation (AU/NZ)',
  businessValidation: 'Business Validation (ABN/ACN)',
  lastUpdatedBy: (username: string) => `Last updated by ${username}`,
  enableGbgIntegration: 'Enable GBG Integration',
  gbgIntegrationEnabled: 'GBG Integration Enabled',
  createConfiguration: 'GBG Integration Setup',
  editConfiguration: 'Edit GBG Configuration',
  enabled: 'Enabled',
  disabled: 'Disabled',
  formLabels: {
    apiBaseUrl: 'API Base URL',
    apiUsername: 'API Username',
    apiToken: 'API Token',
    apiTokenEdit: 'API Token (Leave blank to keep existing token)',
    isAddressValidationEnabled: 'Enable Address Validation (AU/NZ)',
    isBusinessValidationEnabled: 'Enable Business Validation (ABN/ACN)',
  },
  save: 'Save',
  required: 'Required',
} as const;
